import { render, staticRenderFns } from "./ComService.vue?vue&type=template&id=11e864ad&scoped=true&"
import script from "./ComService.vue?vue&type=script&lang=js&"
export * from "./ComService.vue?vue&type=script&lang=js&"
import style0 from "./ComService.vue?vue&type=style&index=0&id=11e864ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e864ad",
  null
  
)

export default component.exports